module.exports = __webpack_public_path__ + "img/3.cd35f005.jpg";